<!-- Data Refreshing Alert -->
@if (fetchingDataFromServer === true && !offlineMode) {
  <div class="alert alert-primary mb-3">
    <div class="fw-bold">
      Fetching Data from Server
      <div class="spinner-grow float-end" role="status"></div>
    </div>
  </div>
}

<!-- Job Data Not Found Alert -->
@if (!jobDetailData && offlineMode && !fetchingDataFromServer) {
  <div class="alert alert-warning mb-2">
    <div>Job Data Not Found</div>
  </div>
}
@if (jobDetailData?.id && !updateTask) {
  <div>
    <!-- Cancellation Reason -->
    @if (
      cancelReasonData && jobDetailData?.status?.status_identity?.value === 2
    ) {
      <div class="alert alert-danger alert-dismissible fade show" role="alert">
        <div>
          <div>
            CANCELLED:
            <span class="fw-bold">
              {{ jobDetailData?.modified_date | date: "d MMM yyyy H:mm" }}
            </span>
          </div>
        </div>
        @if (cancelReasonData?.reason) {
          <div>
            <div>
              CANCEL REASON:
              <span class="fw-bold">{{ cancelReasonData?.reason }}</span>
            </div>
          </div>
        }
      </div>
    }
    <div>
      <div
        [style.padding-bottom]="bottomSectionFixedHeight + ' !important'"
        id="jobDetail"
        class="mb-2"
      >
        <div class="row row-cols-1 row-cols-lg-2 mb-lg-3">
          <div
            class="col col-lg-8 d-flex flex-wrap column-gap-5 row-gap-3 p-3 p-lg-4 border-lg border-lg-3 rounded"
          >
            <div class="min-vw-75">
              <dl id="jobSiteInfo">
                <div
                  class="d-flex align-items-center"
                  (click)="
                    !offlineMode &&
                    !jobDetailData?.sites?.[0]?.is_deleted &&
                    !jobDetailData?.company?.is_deleted &&
                    (isAdmin || isDispatchUser)
                      ? onlineRedirect('site')
                      : null
                  "
                >
                  <div class="flex-grow-1">
                    <dt>Site</dt>
                    <dd
                      [ngClass]="!offlineMode ? 'link-view' : ''"
                      [class.link-view]="
                        !offlineMode &&
                        !jobDetailData?.sites?.[0]?.is_deleted &&
                        !jobDetailData?.company?.is_deleted &&
                        (isAdmin || isDispatchUser)
                      "
                    >
                      {{ jobDetailData?.sites?.[0]?.company_name }}
                      <br />
                      <span class="small">{{
                        jobDetailData?.company?.company_name
                      }}</span>
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
            <div id="jobAddressLink">
              <dl>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dt>Address</dt>
                    <dd>
                      <a
                        class="link-view"
                        [href]="
                          'https://www.google.com/maps/search/?api=1&query=' +
                          jobDetailData?.sites?.[0]?.address?.latitude +
                          ',' +
                          jobDetailData?.sites?.[0]?.address?.longitude
                        "
                        target="_blank"
                      >
                        {{ jobDetailData?.sites?.[0]?.address?.full_address }}
                      </a>
                    </dd>
                  </div>
                  <div id="jobAddressLink" class="d-none">
                    <a
                      [href]="
                        'https://www.google.com/maps/search/?api=1&query=' +
                        jobDetailData?.sites?.[0]?.address?.latitude +
                        ',' +
                        jobDetailData?.sites?.[0]?.address?.longitude
                      "
                      target="_blank"
                    >
                      <span class="me-1">
                        <i class="fa-solid fa-route md-font-size"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </dl>
            </div>
            @if ((isAdmin || isDispatchUser) && !jobDetailData?.run_sheet?.id) {
              <div>
                <dl>
                  <div class="d-flex align-items-center">
                    <div
                      class="flex-grow-1"
                      (click)="
                        ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                          jobDetailData?.status?.status_identity?.value
                        ) && !offlineMode
                          ? modifyAssignees(singleAssigneeSelectionTemplate)
                          : null
                      "
                      role="button"
                    >
                      <dt>
                        {{
                          jobDetailData?.assignee?.length > 1
                            ? "Assigned Guards"
                            : "Assigned Guard"
                        }}
                      </dt>
                      <dd
                        class="d-flex align-items-center"
                        [class.link-edit]="
                          ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                            jobDetailData?.status?.status_identity?.value
                          ) && !offlineMode
                        "
                      >
                        @if (jobDetailData?.assignee?.length) {
                          @if (
                            jobDetailData?.assignee[0]?.acceptance_status === 2
                          ) {
                            <span
                              title="Pending Acceptance"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              class="text-warning fw-bold fs-5 me-1"
                              ><i class="fa-solid fa-circle-question"></i
                            ></span>
                          }
                          @if (
                            jobDetailData?.assignee[0]?.acceptance_status === 1
                          ) {
                            <span
                              title="Shift Accepted"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              class="text-success fw-bold fs-5 me-1"
                              ><i class="fa-solid fa-circle-check"></i
                            ></span>
                          }
                          <span
                            [gtappPopover]="userDetailPopoverTemplate"
                            [popoverData]="{
                              userId: jobDetailData?.assignee[0]?.id,
                            }"
                          >
                            {{ jobDetailData?.assignee[0]?.full_name }}
                          </span>
                        } @else {
                          <div class="text-danger">Not Assigned</div>
                        }
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
            }
            @if (!jobDetailData?.run_sheet?.id) {
              <div>
                <dl id="jobType">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Job Type</dt>
                      <dd>
                        <span
                          [ngClass]="
                            [0, 1, 5].includes(
                              jobDetailData?.service_type?.type_identity
                            ) &&
                            !offlineMode &&
                            ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                              jobDetailData?.status?.status_identity?.value
                            ) &&
                            (isAdmin || isDispatchUser)
                              ? 'link-edit'
                              : ''
                          "
                          (click)="
                            [0, 1, 5].includes(
                              jobDetailData?.service_type?.type_identity
                            ) &&
                            !offlineMode &&
                            ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                              jobDetailData?.status?.status_identity?.value
                            ) &&
                            (isAdmin || isDispatchUser)
                              ? [0, 5].includes(
                                  jobDetailData?.service_type?.type_identity
                                )
                                ? openUpdateResponseTypeTemplate(
                                    responseTypeTemplateRef
                                  )
                                : openUpdateServiceTypeTemplate(
                                    serviceTypeTemplateRef
                                  )
                              : ''
                          "
                        >
                          {{ jobDetailData?.service_type?.name }}
                          @if (jobDetailData?.response_type?.name) {
                            <span
                              >&nbsp;-&nbsp;
                              <span class="fw-bold">{{
                                jobDetailData?.response_type?.name
                              }}</span>
                            </span>
                          }
                          @if (jobDetailData?.job_service_type?.name) {
                            <span
                              >&nbsp;-&nbsp;
                              <span class="fw-bold">{{
                                jobDetailData?.job_service_type?.name
                              }}</span>
                            </span>
                          }
                        </span>
                        <div class="d-none">
                          @if (
                            [0].includes(
                              jobDetailData?.service_type?.type_identity
                            ) &&
                            (jobDetailData?.job_received_at ||
                              ![1, 2, 3, 10, 11, 12, 13].includes(
                                jobDetailData?.status?.status_identity?.value
                              ))
                          ) {
                            <br />
                            <dt class="d-inline pe-1">Received</dt>
                            <dd
                              [class.link-edit]="
                                (isAdmin || isDispatchUser) &&
                                !offlineMode &&
                                jobDetailData?.job_received_at &&
                                ![1, 2, 3, 10, 11, 12, 13].includes(
                                  jobDetailData?.status?.status_identity?.value
                                )
                              "
                              (click)="
                                !offlineMode &&
                                ![1, 2, 3, 10, 11, 12, 13].includes(
                                  jobDetailData?.status?.status_identity?.value
                                ) &&
                                (isAdmin || isDispatchUser)
                                  ? openReceivedAtTemplate(
                                      jobReceivedAtTemplateRef
                                    )
                                  : ''
                              "
                            >
                              @if (jobDetailData?.job_received_at) {
                                <span class="text-danger">
                                  {{
                                    jobDetailData?.job_received_at
                                      | customDate: "d MMM y HH:mm"
                                  }}
                                </span>
                              } @else {
                                <div
                                  class="rounded border shadow p-2 px-5 my-2 text-center hover"
                                  role="button"
                                >
                                  <i class="fa-solid fa-plus"></i>
                                </div>
                              }
                            </dd>
                          }
                        </div>
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
            }
            @if (
              [0].includes(jobDetailData?.service_type?.type_identity) &&
              (jobDetailData?.job_received_at ||
                ![1, 2, 3, 10, 11, 12, 13].includes(
                  jobDetailData?.status?.status_identity?.value
                ))
            ) {
              <div>
                <dl>
                  <dt>Alarm Received</dt>
                  <dd
                    [class.link-edit]="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      jobDetailData?.job_received_at &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                    "
                    (click)="
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      (isAdmin || isDispatchUser)
                        ? openReceivedAtTemplate(jobReceivedAtTemplateRef)
                        : ''
                    "
                  >
                    @if (jobDetailData?.job_received_at) {
                      {{
                        jobDetailData?.job_received_at
                          | customDate: "d MMM y HH:mm"
                      }}
                      @if (
                        jobReceivedDuration &&
                        [0, 4, 5, 8].includes(
                          jobDetailData?.status?.status_identity?.value
                        )
                      ) {
                        <span class="fw-semibold">
                          ({{ jobReceivedDuration }} ago)
                        </span>
                      }
                    } @else {
                      <div
                        class="rounded border shadow p-1 px-5 text-center hover"
                        role="button"
                      >
                        <i class="fa-solid fa-comment-dots text-body fa-2x"></i>
                      </div>
                    }
                  </dd>
                </dl>
              </div>
            }
            <!--seal cleared info-->
            @if (
              jobDetailData?.seal_info?.internal_check &&
              [0, 5].includes(jobDetailData?.service_type?.type_identity)
            ) {
              <div style="position: relative; top: -7px">
                <!-- exclusive for response jobs-->
                <dl>
                  <div class="d-flex align-items-center gap-2">
                    <div class="flex-grow-1">
                      <dt>Seal Status</dt>
                    </div>
                    @if (
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      !jobDetailData?.seal_info?.site_sealed &&
                      !jobDetailData?.seal_info?.uncleared_reason &&
                      (isAdmin || isDispatchUser)
                    ) {
                      <div>
                        <button
                          (click)="
                            openSealInfoTemplate(sealInfoTemplateRef, true)
                          "
                          class="btn btn-success btn-sm"
                        >
                          Seal Obtained
                        </button>
                      </div>
                    }
                  </div>
                  <dd class="gt-multi-line">
                    <div
                      class="fw-semibold"
                      [ngClass]="
                        jobDetailData?.seal_info?.site_sealed
                          ? 'text-success'
                          : 'text-danger fw-semibold'
                      "
                    >
                      {{
                        jobDetailData?.seal_info?.site_sealed
                          ? "Seal Confirmed"
                          : "Pending - Not Sealed"
                      }}
                    </div>
                    @if (
                      !jobDetailData?.seal_info?.site_sealed &&
                      jobDetailData?.seal_info?.uncleared_reason
                    ) {
                      Reason:
                      {{ jobDetailData?.seal_info?.uncleared_reason }}
                    }
                    @if (
                      jobDetailData?.seal_info?.site_sealed &&
                      jobDetailData?.seal_info?.cleared_by
                    ) {
                      <div
                        [ngClass]="
                          !offlineMode &&
                          ![1, 2, 3, 10, 11, 12, 13].includes(
                            jobDetailData?.status?.status_identity?.value
                          ) &&
                          (jobDetailData?.seal_info?.site_sealed ||
                            jobDetailData?.seal_info?.uncleared_reason) &&
                          (isAdmin || isDispatchUser)
                            ? 'link-edit'
                            : ''
                        "
                        (click)="
                          !offlineMode &&
                          ![1, 2, 3, 10, 11, 12, 13].includes(
                            jobDetailData?.status?.status_identity?.value
                          ) &&
                          (jobDetailData?.seal_info?.site_sealed ||
                            jobDetailData?.seal_info?.uncleared_reason) &&
                          (isAdmin || isDispatchUser)
                            ? openSealInfoTemplate(sealInfoTemplateRef, false)
                            : ''
                        "
                      >
                        Cleared By:
                        <span class="fw-semibold">{{
                          jobDetailData?.seal_info?.cleared_by
                        }}</span>
                      </div>
                    }
                  </dd>
                </dl>
              </div>
            }
            @if (jobDetailData?.roster_scheduler?.repeat_type) {
              <div id="shiftInfo">
                <dl>
                  <!-- Date/Duration Section -->
                  <dt>Start Date</dt>
                  <dd>
                    {{
                      jobDetailData?.schedule_event_date
                        ? (jobDetailData?.schedule_event_date | date: "d MMM y")
                        : (jobDetailData?.roster_scheduler?.start_day
                          | date: "d MMM y")
                    }}
                  </dd>
                </dl>
              </div>
              <div>
                <dl>
                  <div
                    class="d-flex align-items-center"
                    [class.link-edit]="
                      canScheduleBeUpdated &&
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      !jobDetailData?.run_sheet?.id
                    "
                    (click)="
                      canScheduleBeUpdated &&
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      !jobDetailData?.run_sheet?.id
                        ? openScheduleTemplate()
                        : null
                    "
                  >
                    <div class="flex-grow-1">
                      <dt>Shift [Start - End]</dt>
                      <dd>
                        {{ jobDetailData?.roster_scheduler?.start_time }} -
                        {{ jobDetailData?.roster_scheduler?.end_time }}
                        <div class="small">({{ scheduleDuration }} Hours)</div>
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
              @if (
                showWelfareItem &&
                !jobDetailData?.run_sheet?.id &&
                (isAdmin || isDispatchUser || jobDetailData?.interval_check > 0)
              ) {
                <div
                  (click)="
                    (isAdmin || isDispatchUser) &&
                    intervalData?.length &&
                    !offlineMode &&
                    ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                      jobDetailData?.status?.status_identity?.value
                    )
                      ? openIntervalCheckTemplate(welfareIntervalTemplate)
                      : null
                  "
                >
                  <dl
                    [class.link-edit]="
                      (isAdmin || isDispatchUser) &&
                      intervalData?.length &&
                      !offlineMode &&
                      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                    "
                  >
                    <dt>Welfare Checks</dt>
                    <dd>
                      @if (jobDetailData?.interval_check == 0) {
                        Disabled
                      } @else {
                        <span class="text-primary fw-medium">
                          <i class="fa-solid fa-person-circle-check"></i>
                          {{ jobDetailData?.interval_check }} mins</span
                        >
                      }
                    </dd>
                  </dl>
                </div>
              }
            }
            <div>
              <dl>
                <dt>Docket No</dt>
                <dd>{{ jobDetailData?.job_key }}</dd>
              </dl>
            </div>

            <!-- @if (jobDetailData?.user_prompts?.user_prompts?.length) {
              <div>
                <dl>
                  <dt>Mobile Forms</dt>
                  <dd>
                    @for (
                      userPrompt of jobDetailData?.user_prompts?.user_prompts;
                      track $index
                    ) {
                      <div
                        class="d-flex gap-2 align-items-center rounded border bg-secondary-subtle mb-1 p-2 ps-3 py-3 hover"
                        role="button"
                        (click)="openPrompterComponent(userPrompt)"
                      >
                        <span>
                          <i class="fa-solid fa-clipboard-list text-success"></i
                        ></span>
                        {{ userPrompt?.[0]?.name }}
                      </div>
                    }
                  </dd>
                </dl>
              </div>
            } -->
            @if (jobDetailData?.run_sheet?.id) {
              <div>
                <dl (click)="redirect('runsheet')">
                  <dt>Patrol Run</dt>
                  <dd class="link-view">
                    {{ jobDetailData?.run_sheet?.name }}
                  </dd>
                </dl>
              </div>
              @if (jobDetailData?.check_list_tasks?.length) {
                <div class="col-12 col-lg-6">
                  <dt>Tasks</dt>
                  @for (
                    task of jobDetailData?.check_list_tasks;
                    track task;
                    let subIndex = $index
                  ) {
                    <div
                      class="rounded border bg-secondary-subtle mb-1"
                      [ngClass]="
                        task?.task_completed_info?.id
                          ? 'p-2 ps-3 pb-1'
                          : 'p-2 ps-3 py-3'
                      "
                      [class.hover]="
                        task?.prompt?.id &&
                        !task?.task_completed_info?.id &&
                        (!jobDetailData?.status?.status_identity?.value ||
                          [4, 5].includes(
                            jobDetailData?.status?.status_identity?.value
                          ))
                      "
                      [attr.role]="
                        task?.prompt?.id &&
                        !task?.task_completed_info?.id &&
                        (!jobDetailData?.status?.status_identity?.value ||
                          [4, 5].includes(
                            jobDetailData?.status?.status_identity?.value
                          ))
                          ? 'button'
                          : ''
                      "
                      (click)="
                        task?.prompt?.id &&
                        !task?.task_completed_info?.id &&
                        (!jobDetailData?.status?.status_identity?.value ||
                          [4, 5].includes(
                            jobDetailData?.status?.status_identity?.value
                          ))
                          ? openCheckListMarkCompleteTemplate(
                              checkListCompleteTemplateRef,
                              task
                            )
                          : null
                      "
                    >
                      <div class="d-flex gap-2 align-items-center">
                        @if (scheduleCheck && !task?.prompt?.id) {
                          <input
                            [checked]="task?.task_completed_info?.id"
                            type="checkbox"
                            [disabled]="
                              task?.task_completed_info?.id ||
                              (![4, 5].includes(
                                jobDetailData?.status?.status_identity?.value
                              ) &&
                                jobDetailData?.status?.status_identity?.value)
                            "
                            readonly
                            [ngClass]="
                              [4, 5].includes(
                                jobDetailData?.status?.status_identity?.value
                              )
                                ? 'opacity-100'
                                : 'opacity-75'
                            "
                            (click)="
                              openCheckListMarkCompleteTemplate(
                                checkListCompleteTemplateRef,
                                task
                              );
                              $event.preventDefault()
                            "
                          />
                        }
                        @if (task?.prompt?.id) {
                          <span>
                            <i
                              class="fa-solid fa-clipboard-list text-success"
                            ></i
                          ></span>
                        }

                        <div
                          class="gt-multi-line text-dark me-4 flex-grow-1"
                          [class.text-decoration-line-through]="
                            task?.task_completed_info?.id
                          "
                        >
                          {{ task?.note }}
                        </div>

                        @if (task?.task_completed_info?.prompts?.length) {
                          <button
                            class="btn btn-outline-secondary btn-sm"
                            (click)="
                              openTemplate(
                                promptTemplate,
                                'prompts',
                                task?.task_completed_info?.prompts
                              );
                              $event.stopImmediatePropagation()
                            "
                          >
                            Details
                          </button>
                        }
                        @if (!isCurrentORFutureSchedule) {
                          <ng-container>
                            @if (!task?.task_completed_info?.id) {
                              <div class="small text-danger fw-bold">
                                [Missed]
                              </div>
                            }
                          </ng-container>
                        } @else if (!task?.task_completed_info?.cachedData) {
                          <ng-container>
                            <div>
                              <div class="d-flex gap-2 justify-content-end">
                                @if (
                                  (isAdmin || isDispatchUser) &&
                                  task?.schedule?.start_datetime &&
                                  !task?.task_completed_info?.id &&
                                  isCurrentORFutureSchedule
                                ) {
                                  <div class="p-2 bg-primary rounded">
                                    <i
                                      class="fa-solid fa-bell md-font-size"
                                      [class.]="task?.schedule?.start_datetime"
                                    ></i>
                                  </div>
                                }
                              </div>
                              @if (
                                task?.schedule?.reminder &&
                                !task?.task_completed_info?.id
                              ) {
                                <div class="small mt-1 text-center">
                                  <span class="text-secondary">Reminder: </span>
                                  <span class="fw-semibold">
                                    @if (task?.schedule?.start_datetime) {
                                      {{
                                        task?.schedule
                                          | misc: "runsheetTaskTiming"
                                      }}
                                    } @else if (task?.schedule?.start_time) {
                                      {{ task?.schedule?.start_time }}
                                    }
                                  </span>
                                </div>
                              }
                            </div>
                          </ng-container>
                        }
                      </div>
                      @if (task?.task_completed_info) {
                        <div class="text-end">
                          @if (task?.task_completed_info?.cachedData) {
                            <div class="ms-1">
                              @if (
                                errorItemsIdsInQueue.has(
                                  task?.task_completed_info?.index_db_id
                                )
                              ) {
                                <span
                                  (click)="
                                    retryUpdate(
                                      task?.task_completed_info?.index_db_id
                                    )
                                  "
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="An error occured while saving data. Retrying."
                                >
                                  <i
                                    class="fa-solid fa-triangle-exclamation text-danger md-font-size"
                                  ></i>
                                </span>
                              } @else {
                                <span
                                  (click)="retrySendingUpdate()"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="This update has not yet been uploaded to the server."
                                >
                                  <i
                                    class="fa-solid fa-triangle-exclamation text-warning md-font-size"
                                  ></i>
                                </span>
                              }
                            </div>
                          }
                          <div class="text-secondary small-font">
                            {{
                              task?.task_completed_info?.updated_datetime
                                | customDate: "d MMM y HH:mm"
                            }}
                            |
                            {{ task?.task_completed_info?.user_name }}
                          </div>
                          {{ task?.task_completed_info?.detail }}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (onSiteOffSiteDict?.onsite) {
                <div>
                  <dl>
                    <dt>Onsite</dt>
                    <dd>
                      {{
                        onSiteOffSiteDict?.onsite | customDate: "d MMM y HH:mm"
                      }}
                    </dd>
                  </dl>
                </div>
              }
              @if (onSiteOffSiteDict?.offsite) {
                <div>
                  <dl>
                    <dt>Offsite</dt>
                    <dd>
                      {{
                        onSiteOffSiteDict?.offsite | customDate: "d MMM y HH:mm"
                      }}
                    </dd>
                  </dl>
                </div>
              }
              @if (
                (isAdmin || isDispatchUser || jobCheckpointListData?.length) &&
                jobDetailData?.sites?.[0]?.cp_count
              ) {
                <div class="col-12 col-lg-6">
                  <dl id="patrolCheckpoints">
                    <dt
                      class="mb-2"
                      [class.link-edit]="
                        isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                      "
                      (click)="
                        isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                          ? onAddCheckpointsToRoute()
                          : null
                      "
                    >
                      Checkpoints [{{ scannedCheckpointCount }} /
                      {{ jobCheckpointListData?.length }}]
                      @if (
                        (isAdmin || isDispatchUser) && isCurrentORFutureSchedule
                      ) {
                        <span
                          class="border rounded ms-2 px-2 bg-primary text-white"
                          >Add / Remove</span
                        >
                      }
                    </dt>
                    <dd class="overflow-45vh">
                      @for (
                        item of jobCheckpointListData;
                        track item;
                        let i = $index
                      ) {
                        <div
                          class="d-flex mb-2 p-2 shadow rounded border"
                          [ngClass]="
                            item?.is_deleted || item?.site_is_deleted
                              ? 'opacity-50'
                              : ''
                          "
                        >
                          <ng-template
                            *ngTemplateOutlet="
                              selectedCheckpointDetail;
                              context: { value: item }
                            "
                          ></ng-template>
                        </div>
                      }
                    </dd>
                  </dl>
                </div>
              }
            }
            @if (
              isAdmin ||
              isDispatchUser ||
              jobDetailData?.location_contacts?.length
            ) {
              <div>
                <dl id="jobOnSiteContacts">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Onsite Contact</dt>
                      <dd
                        class="link-edit"
                        (click)="
                          modifySiteContactTemplate(modifySiteContactRef)
                        "
                      >
                        {{ jobDetailData?.location_contacts[0]?.full_name }}
                        @if (!jobDetailData?.location_contacts?.length) {
                          <div style="color: var(--color-danger-500)">N/A</div>
                        }
                      </dd>
                    </div>
                    <div class="d-flex align-items-center d-none">
                      @if (jobDetailData?.location_contacts?.length > 1) {
                        <div class="me-4">
                          <button
                            class="btn btn-outline-secondary btn-sm"
                            (click)="
                              modifySiteContactTemplate(modifySiteContactRef)
                            "
                          >
                            +
                            {{ jobDetailData?.location_contacts?.length - 1 }}
                            more
                          </button>
                        </div>
                      }
                      <span
                        (click)="
                          modifySiteContactTemplate(modifySiteContactRef)
                        "
                        class="me-1"
                      >
                        <i
                          class="fa-solid fa-arrow-up-right-from-square md-font-size text-secondary"
                        ></i>
                      </span>
                    </div>
                  </div>
                </dl>
              </div>
            }
            @if (
              (jobDetailData?.monitoring_company?.id ||
                isAdmin === true ||
                isDispatchUser === true) &&
              [0, 5].includes(jobDetailData?.service_type?.type_identity)
            ) {
              <div>
                <dl>
                  <dt>Monitoring Company</dt>
                  <dd
                    [class.link-edit]="
                      !offlineMode &&
                      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      (isAdmin || isDispatchUser)
                    "
                    (click)="
                      !offlineMode &&
                      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      (isAdmin || isDispatchUser)
                        ? modifyMonitoringCompany(modifyMCTemplate)
                        : ''
                    "
                  >
                    {{
                      jobDetailData?.monitoring_company?.company_name
                        ? jobDetailData?.monitoring_company?.company_name
                        : "N/A"
                    }}
                  </dd>
                </dl>
              </div>
            }
            @if (
              [0, 5, 2].includes(jobDetailData?.service_type?.type_identity) &&
              (isAdmin || isDispatchUser || jobDetailData?.ext_job_id)
            ) {
              <div>
                <dl>
                  <dt>Job Number</dt>
                  <dd
                    [class.link-edit]="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                    "
                    (click)="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                        ? modifyExternalJobId(modifyExternalJobIdTemplate)
                        : ''
                    "
                  >
                    {{
                      jobDetailData?.ext_job_id
                        ? jobDetailData?.ext_job_id
                        : "N/A"
                    }}
                  </dd>
                </dl>
              </div>
            }
            @if (
              [2].includes(jobDetailData?.service_type?.type_identity) &&
              (isAdmin || isDispatchUser || jobDetailData?.position)
            ) {
              <div>
                <dl>
                  <dt>Position</dt>
                  <dd
                    [class.link-edit]="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                    "
                    (click)="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                        ? modifyShiftPosition(shiftPositionTempate)
                        : ''
                    "
                  >
                    {{
                      jobDetailData?.position ? jobDetailData?.position : "N/A"
                    }}
                  </dd>
                </dl>
              </div>
            }
            @if (jobDetailData?.sites?.[0]?.site_information) {
              <div>
                <dl>
                  <!--site information-->
                  <dt>Site Information</dt>
                  <dd class="gt-multi-line">
                    {{
                      jobDetailData?.sites?.[0]?.site_information
                        ? jobDetailData?.sites?.[0]?.site_information
                        : "No details provided"
                    }}
                  </dd>
                </dl>
              </div>
            }
            @if (jobDetailData?.sites?.[0]?.site_files?.length) {
              <div>
                <dl>
                  <dt>Site Files</dt>
                  <dd class="d-flex gap-2 flex-wrap">
                    @for (
                      file of jobDetailData?.sites?.[0]?.site_files;
                      track file;
                      let i = $index
                    ) {
                      <div class="d-flex align-items-center">
                        <div class="border px-2 py-1 rounded link-view">
                          <span (click)="onOpenFile(file)">
                            <span class="badge bg-primary me-2">{{
                              file?.extension
                            }}</span>
                            <span> {{ file?.description }}</span>
                          </span>
                        </div>
                      </div>
                    }
                  </dd>
                </dl>
              </div>
            }
            @if (
              jobDetailData?.sites?.[0]?.id &&
              jobDetailData?.sites?.[0]?.site_key_exists
            ) {
              <gtapp-site-keys
                [selectedSite]="jobDetailData?.sites?.[0]"
                [showManageOption]="false"
              ></gtapp-site-keys>
            }
            @if (isAdmin || isDispatchUser || jobDetailData?.internal_notes) {
              <div>
                <dl>
                  <!--internal notes-->
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>
                        Internal Notes
                        @if (isAdmin || isDispatchUser) {
                          <span
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Will not be shown on reports"
                            ><i
                              class="fa-solid fa-circle-info text-secondary"
                            ></i
                          ></span>
                        }
                      </dt>
                    </div>
                  </div>
                  <dd
                    class="gt-multi-line"
                    [ngClass]="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                        ? 'link-edit'
                        : ''
                    "
                    (click)="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                        ? modifyJobExtraInfo(
                            jobExtraInfoTemplateRef,
                            'in',
                            jobDetailData?.internal_notes
                          )
                        : ''
                    "
                  >
                    {{
                      jobDetailData?.internal_notes
                        ? jobDetailData?.internal_notes
                        : "No notes provided"
                    }}
                  </dd>
                </dl>
              </div>
            }
            @if (isAdmin || isDispatchUser || jobDetailData?.request_details) {
              <div>
                <dl id="jobAI">
                  <!--additionala information-->
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Additional Information</dt>
                    </div>
                  </div>
                  <dd
                    class="gt-multi-line"
                    [ngClass]="
                      (isAdmin || isDispatchUser) &&
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                        ? 'link-edit'
                        : ''
                    "
                    (click)="
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                        ? modifyJobExtraInfo(
                            jobExtraInfoTemplateRef,
                            'ai',
                            jobDetailData?.request_details
                          )
                        : ''
                    "
                  >
                    {{
                      jobDetailData?.request_details
                        ? jobDetailData?.request_details
                        : "No details provided"
                    }}
                  </dd>
                </dl>
              </div>
            }
            <!--          <div>-->
            <!--            <dl-->
            <!--              *ngIf="-->
            <!--                jobDetailData.service_type?.type_identity !== 0 &&-->
            <!--                (isAdmin || isDispatchUser) &&-->
            <!--                ![1, 2, 3,9,10,11,12].includes(jobDetailData?.status?.status_identity?.value)-->
            <!--              "-->
            <!--            >-->
            <!--              <div class="d-flex align-items-center">-->
            <!--                <div class="flex-grow-1">-->
            <!--                  <dt>Geofence Alert</dt>-->
            <!--                  <dd>-->
            <!--                    @if( jobDetailData?.additional_info?.geofence_distance> 0){-->
            <!--                    {{-->
            <!--                      jobDetailData?.additional_info?.geofence_distance || 0-->
            <!--                        | number : "1.0-0"-->
            <!--                    }}-->
            <!--                    metres away from site }@else { Not Configured }-->
            <!--                  </dd>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    (click)="openFenceAlertTemplate(geoFenceAlertDistanceRef)"-->
            <!--                    class="me-1"-->
            <!--                    *ngIf="-->
            <!--                      (isAdmin || isDispatchUser) &&-->
            <!--                      !offlineMode &&-->
            <!--                      ![1, 2, 3,9,10,11,12].includes(-->
            <!--                        jobDetailData?.status?.status_identity?.value-->
            <!--                      )-->
            <!--                    "-->
            <!--                  >-->
            <!--                    <i-->
            <!--                      class="fa-solid fa-pen-to-square md-font-size text-secondary"-->
            <!--                    ></i>-->
            <!--                  </span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </dl>-->
            <!--          </div>-->

            <!-- Comments -->

            @if (!largeView) {
              <div class="col-12">
                @if (jobCommentsFilesStatusData?.length) {
                  <div class="text-end my-3">
                    <button
                      class="btn btn-sm btn-dark"
                      (click)="changeSortOrder = !changeSortOrder"
                      [disabled]="jobCommentsFilesStatusData?.length < 2"
                    >
                      Sort
                      <span>
                        <i class="fa-solid fa-sort"></i>
                      </span>
                    </button>
                  </div>
                }
                @for (
                  msg of changeSortOrder
                    ? jobCommentsFilesStatusData?.slice()?.reverse()
                    : jobCommentsFilesStatusData;
                  track msg;
                  let i = $index
                ) {
                  <div
                    class="d-flex flex-column flex-wrap border rounded p-2 mb-2 shadow"
                  >
                    <dl
                      [ngClass]="
                        msg?.is_deleted || isItemNotShownInReport(msg)
                          ? 'opacity-50'
                          : ''
                      "
                    >
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1 small-font">
                          <dt>
                            <!--update details section-->
                            @if (msg?.file) {
                              <span>
                                {{
                                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                                    msg?.file_extension
                                  )
                                    ? "Video"
                                    : "Photo"
                                }}
                                {{
                                  msg?.event_action === 19
                                    ? "[Device Library]"
                                    : "[Camera]"
                                }}
                                |
                              </span>
                            }
                            {{
                              msg?.updated_datetime ?? msg?.updated_at
                                | customDate: "d MMM y HH:mm"
                            }}
                            |
                            {{
                              subscriberUserId == msg?.subs_user_id
                                ? "You"
                                : msg?.user_name
                            }}
                            @if (
                              msg?.history_changes?.length &&
                              (subscriberUserId == msg?.subs_user_id ||
                                isAdmin ||
                                isDispatchUser)
                            ) {
                              <span>
                                | Edited [{{
                                  (
                                    msg?.history_changes
                                    | misc: "lastCommentEditedDateTime"
                                  )?.updated_at | customDate: "d MMM y HH:mm"
                                }}]</span
                              >
                            }
                          </dt>
                        </div>
                        @if (msg?.id && !msg?.cachedData) {
                          @if (
                            (subscriberUserId == msg?.subs_user_id ||
                              isAdmin ||
                              isDispatchUser) &&
                            ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                              jobDetailData?.status?.status_identity?.value
                            ) &&
                            !offlineMode &&
                            [7, 8, 19].includes(msg?.event_action)
                          ) {
                            <div
                              (click)="
                                deleteRestoreUserUpdate({
                                  event: msg,
                                  type: msg?.is_deleted ? 'restore' : 'delete',
                                })
                              "
                              class="ms-1"
                            >
                              @if (msg?.is_deleted) {
                                <span>
                                  <i
                                    class="fa-regular fa-square-plus md-font-size text-secondary"
                                  ></i>
                                </span>
                              } @else {
                                <span>
                                  <i
                                    class="fa-regular fa-square-minus md-font-size text-secondary"
                                  ></i>
                                </span>
                              }
                            </div>
                          }
                        }
                        @if (!msg?.id && msg?.index_db_id) {
                          <!--item not in server but in indeced db in that case provide option to delete it from index db-->
                          <span (click)="deleteItemFromNativeDb(msg)">
                            <i
                              class="fa-solid fa-trash md-font-size text-secondary"
                            ></i>
                          </span>
                        }
                        @if (msg?.cachedData) {
                          <div class="ms-1">
                            @if (errorItemsIdsInQueue.has(msg?.index_db_id)) {
                              <span
                                (click)="retrySendingUpdate()"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="An error occured while saving data. Retrying."
                              >
                                <i
                                  class="fa-solid fa-triangle-exclamation text-danger md-font-size"
                                ></i>
                              </span>
                            } @else {
                              <span
                                (click)="retrySendingUpdate()"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="This update has not yet been uploaded to the server."
                              >
                                <i
                                  class="fa-solid fa-triangle-exclamation text-warning md-font-size"
                                ></i>
                              </span>
                            }
                          </div>
                        }
                      </div>
                      <dd>
                        <!-- comment / photo -->
                        @if (msg?.event_action === 20) {
                          <div>CHECKED IN</div>
                        }
                        <div class="pb-3">
                          <span
                            class="gt-multi-line"
                            [ngClass]="
                              (subscriberUserId == msg?.subs_user_id ||
                                isAdmin ||
                                isDispatchUser) &&
                              ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                                jobDetailData?.status?.status_identity?.value
                              ) &&
                              !offlineMode &&
                              [7, 8, 19].includes(msg?.event_action) &&
                              !msg?.is_deleted &&
                              msg?.id &&
                              !msg?.cachedData
                                ? 'link-edit'
                                : ''
                            "
                            (click)="
                              (subscriberUserId == msg?.subs_user_id ||
                                isAdmin ||
                                isDispatchUser) &&
                              ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                                jobDetailData?.status?.status_identity?.value
                              ) &&
                              !offlineMode &&
                              [7, 8, 19].includes(msg?.event_action) &&
                              !msg?.is_deleted &&
                              msg?.id &&
                              !msg?.cachedData
                                ? openTemplate(
                                    addEditCommentTemplate,
                                    'editComment',
                                    msg
                                  )
                                : ''
                            "
                          >
                            {{ msg?.event_action === 1 ? "STATUS: " : "" }}
                            @if (
                              (msg?.detail === "null" ||
                                msg?.detail === "undefined" ||
                                !msg?.detail) &&
                              (subscriberUserId == msg?.subs_user_id ||
                                isAdmin ||
                                isDispatchUser) &&
                              ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                                jobDetailData?.status?.status_identity?.value
                              ) &&
                              !offlineMode &&
                              [7, 8, 19].includes(msg?.event_action) &&
                              !msg?.is_deleted &&
                              msg?.id &&
                              !msg?.cachedData
                            ) {
                              <div
                                class="rounded border shadow p-1 px-5 text-center hover"
                                role="button"
                              >
                                <i
                                  class="fa-solid fa-comment-dots text-body fa-2x"
                                ></i>
                              </div>
                            } @else {
                              {{ msg?.detail }}
                            }
                          </span>
                        </div>
                        @if (msg?.file) {
                          <ng-template
                            *ngTemplateOutlet="
                              filePreviewTemplate;
                              context: {
                                value: msg,
                                inBrowser: !msg?.id && !isNativeApp,
                              }
                            "
                          ></ng-template>
                        }
                        <div class="small-font text-secondary text-end">
                          @if (
                            (msg | misc: "getEventUpadteFilters" : "job")
                              ?.delete?.updated_at
                          ) {
                            <div>
                              Deleted:
                              {{
                                (msg | misc: "getEventUpadteFilters" : "job")
                                  ?.delete?.updated_at
                                  | customDate: "d MMM y HH:mm"
                              }}
                              |
                              {{
                                (msg | misc: "getEventUpadteFilters" : "job")
                                  ?.delete?.user_name
                              }}
                            </div>
                          }
                          @if (
                            (msg | misc: "getEventUpadteFilters" : "job")
                              ?.restore?.updated_at && !msg?.is_deleted
                          ) {
                            Restored:
                            {{
                              (msg | misc: "getEventUpadteFilters" : "job")
                                ?.restore?.updated_at
                                | customDate: "d MMM y HH:mm"
                            }}
                            |
                            {{
                              (msg | misc: "getEventUpadteFilters" : "job")
                                ?.restore?.user_name
                            }}
                          }
                        </div>
                      </dd>
                    </dl>
                  </div>
                }
              </div>
            }
          </div>
          @if (largeView) {
            <div class="col col-lg-4 p-lg-3" id="jobUpdate">
              <ng-template
                *ngTemplateOutlet="jobActionTemplateRef"
              ></ng-template>
            </div>
          }
          @if (!largeView) {
            <div id="bottom-section-fixed" class="bottom-section">
              <div id="jobUpdate" class="p-2 my-0">
                <ng-template
                  *ngTemplateOutlet="jobActionTemplateRef"
                ></ng-template>
              </div>
            </div>
          }
        </div>
        @if (largeView) {
          @if (jobHistoryData?.length) {
            <div class="row row-cols-3 border border-3">
              <div class="col">
                <gtapp-gt-table
                  id="jobHistory"
                  [desktopTableUIData]="
                    isAdmin || isDispatchUser
                      ? jobHistoryData
                      : jobCommentsFilesStatusData
                  "
                  [desktopTableDetails]="jobDetailsTableView"
                  [otherParams]="otherParams"
                  [tableStyle]="{
                    'overflow': 'auto',
                    'max-height': '400px',
                  }"
                  (rowClick)="onTableRowClick($event)"
                ></gtapp-gt-table>
              </div>
              <div class="col-8">
                <!-- SELECTED DETAILS -->
                @if (selectedEvent) {
                  <gtapp-updated-event-detail
                    [selectedEvent]="selectedEvent"
                    [userEventDetailsTableView]="jobDetailsTableView"
                    selectedEventFrom="job"
                    [extraCheck]="
                      !offlineMode &&
                      ![1, 2, 3, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      )
                    "
                    (editUserComment)="
                      openTemplate(
                        addEditCommentTemplate,
                        'editComment',
                        $event
                      )
                    "
                    (deleteRestoreUserUpdate)="deleteRestoreUserUpdate($event)"
                  ></gtapp-updated-event-detail>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
}

@if (["scanCheckPoint"].includes(updateTask)) {
  <gtapp-update-events
    [detailType]="updateTask"
    [details]="{
      filterPatrolData: filterPatrolData,
      jobId: jobDetailData?.id,
    }"
    (emitData)="updateTask = null; getCheckPointScans()"
  >
  </gtapp-update-events>
}
<ng-template
  #geoFenceAlertDistanceRef
  let-geoFenceAlertDistanceRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Geofence Alert

      <span class="float-end" (click)="geoFenceAlertDistanceRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data?.seeRadiusOnly) {
      <ng-container>
        <gtapp-map-leaflet
          [latLon]="{
            lat: jobDetailData?.sites?.[0]?.address?.latitude,
            lon: jobDetailData?.sites?.[0]?.address?.longitude,
            geoFenceRadius: jobDetailData?.additional_info?.geofence_distance,
          }"
          mapId="smallMapOtherJob"
        ></gtapp-map-leaflet
      ></ng-container>
    } @else {
      <ng-container>
        <gtapp-map-leaflet
          [latLon]="{
            lat: jobDetailData?.sites?.[0]?.address?.latitude,
            lon: jobDetailData?.sites?.[0]?.address?.longitude,
          }"
          [changableRadius]="true"
          [mapRadiusParams]="{
            minKm: 0,
            maxKm: 5000,
            nearestKmValue: jobDetailData?.additional_info?.geofence_distance,
          }"
          mapId="smallMapOtherJob"
          (updateMinDistance)="updateMinDistance($event)"
        ></gtapp-map-leaflet>
      </ng-container>
    }
    @if (!data?.seeRadiusOnly) {
      <div class="row row-cols-3">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="geoFenceAlertDistanceRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-danger"
            (click)="
              geoFenceAlertDistanceRef.close();
              geoAlertDistance = 0;
              updateGeoFenceAlert()
            "
          >
            Remove Alert
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            (click)="updateGeoFenceAlert(); geoFenceAlertDistanceRef.close()"
          >
            Update
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #jobActionTemplateRef>
  @if (
    ![1, 2, 3, 9, 10, 11, 12, 13].includes(
      jobDetailData?.status?.status_identity?.value
    )
  ) {
    <ng-container>
      <!-- check JobStatus model or global.variable.ts page for status info-->

      <div
        class="text-center p-2 fw-bold rounded-2 mb-lg-2"
        [style]="selectedJobStatus?.additional_info?.style?.snubbed"
      >
        {{
          selectedJobStatus?.name
            ? selectedJobStatus?.name
            : isJobStale
              ? "STALE"
              : "NOT STARTED"
        }}
        @if (selectedJobStatus?.status_identity?.value === 4) {
          <div class="fw-semibold">{{ onsiteTimer }}</div>
        }
        @if (jobDetailData?.status?.status_identity?.value === 8) {
          <!--show only when the status in 'In Transit'-->
          @if (jobDetailData?.etaDiff?.minutes) {
            @if (jobDetailData?.showEta) {
              <div
                class="cursor-pointer fw-normal rounded-1 border border-primary text-dark m-auto py-2 px-2 w-75 bg-secondary bg-gradient text-white"
                (click)="
                  offlineMode
                    ? showOfflineMessage()
                    : jobDetailData?.status?.status_identity?.value === 8
                      ? openInTransitTemplate(inTransitTemplateRef)
                      : ''
                "
              >
                <span>
                  <i class="fa-regular fa-clock text-white"></i>
                </span>
                ETA:
                <span class="fw-semibold">
                  {{ jobDetailData?.eta | customDate: "h:mm a" }}</span
                >
                @if (!jobDetailData?.sameDay) {
                  <span> {{ jobDetailData?.eta | customDate: "d MMM y" }}</span>
                }
                @if (jobDetailData?.etaDiff?.minutes > 0) {
                  ({{ jobDetailData?.etaDiff?.minutes }} minutes)
                } @else {
                  <!-- Only show if job is still In Transit -->
                  <span class="text-white bg-danger px-1">
                    {{ jobDetailData?.etaDiff?.minutes * -1 }} mins late</span
                  >
                }
              </div>
            }
          } @else {
            <span
              class="p-1"
              (click)="
                offlineMode
                  ? showOfflineMessage()
                  : jobDetailData?.status?.status_identity?.value === 8
                    ? openInTransitTemplate(inTransitTemplateRef)
                    : ''
              "
            >
              <i class="fa-regular fa-clock app-link"></i>
            </span>
          }
        }
      </div>
      <!--allow clock out only after shift is changed to offsite. https://app.shortcut.com/sendem/story/13915/refactor-time-attendance-static-shifts-->
      @if (
        shiftClockInOutParms.requiresClockInOut &&
        shiftClockInOutParms.hasUserClockedIn &&
        !shiftClockInOutParms.hasUserClockedOut &&
        [5].includes(jobDetailData?.status?.status_identity?.value) &&
        ![2].includes(jobDetailData?.service_type?.type_identity)
      ) {
        <div class="col my-2">
          <button
            class="btn btn-md w-100 btn-warning"
            (click)="onClockInOutUser()"
          >
            Clock Out
          </button>
        </div>
      }
      @if (canDeclineJob && !requiresAcceptance) {
        <button
          class="btn btn-lg w-100 btn-danger my-2"
          (click)="openJobDeclineTemplate(jobDeclineTemplateRef)"
        >
          Decline
        </button>
      }
      @if (requiresAcceptance) {
        <div class="row row-cols-2 my-2">
          <div class="col">
            <button
              class="btn btn-lg w-100 btn-success"
              (click)="updateJobDetail({ accept_job: subscriberUserId })"
            >
              Accept
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-lg w-100 btn-danger"
              (click)="openJobDeclineTemplate(jobDeclineTemplateRef)"
            >
              Decline
            </button>
          </div>
        </div>
      } @else if (
        shiftClockInOutParms.requiresClockInOut &&
        !shiftClockInOutParms.hasUserClockedIn &&
        ![2].includes(jobDetailData?.service_type?.type_identity)
      ) {
        <div class="col my-2">
          <button
            class="btn btn-md w-100 btn-primary"
            [disabled]="!scheduleCheck"
            (click)="onClockInOutUser()"
          >
            Clock In
          </button>
        </div>
      } @else {
        @if (largeView) {
          @if (scheduleCheck && !offlineMode) {
            <div class="row row-cols-2 g-1">
              @if (availableStatusesListData?.length) {
                <div
                  class="col-12"
                  (click)="statusDropdownOpen = !statusDropdownOpen"
                >
                  @if (availableStatusesListData?.length === 1) {
                    <div
                      [ngStyle]="
                        availableStatusesListData[0]?.status?.additional_info
                          ?.style?.snubbed
                      "
                      class="btn w-100 rounded fw-bold py-2"
                      (click)="
                        changeJobStatus(
                          availableStatusesListData[0],
                          jobCancelTemplate,
                          inTransitTemplateRef,
                          queuedEventsTemplateRef,
                          siteUpdateRadiusWarningTemplate
                        )
                      "
                    >
                      {{ availableStatusesListData[0]?.status?.name }}
                      <ng-template
                        *ngTemplateOutlet="
                          attachClockInOutToStatusTemplate;
                          context: { status: availableStatusesListData[0] }
                        "
                      ></ng-template>
                    </div>
                  } @else {
                    <button
                      class="btn btn-outline-primary w-100 btm-btn-height rounded d-flex align-items-center justify-content-center bg-secondary-subtle"
                      (blur)="closeStatusDropDown()"
                    >
                      Update
                      <div class="ms-4">
                        @if (statusDropdownOpen) {
                          <span>
                            <i class="fas fa-chevron-up"></i>
                          </span>
                        } @else {
                          <span>
                            <i class="fas fa-chevron-down"></i>
                          </span>
                        }
                      </div>
                    </button>
                    @if (statusDropdownOpen) {
                      <div class="col dropdown">
                        <div class="dropdown-content-down">
                          @for (item of availableStatusesListData; track item) {
                            <a
                              (click)="
                                changeJobStatus(
                                  item,
                                  jobCancelTemplate,
                                  inTransitTemplateRef,
                                  queuedEventsTemplateRef,
                                  siteUpdateRadiusWarningTemplate
                                );
                                statusDropdownOpen = false
                              "
                              >{{ item?.status?.name }}
                              <ng-template
                                *ngTemplateOutlet="
                                  attachClockInOutToStatusTemplate;
                                  context: { status: item }
                                "
                              ></ng-template
                            ></a>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }
              <div class="col">
                @if (jobDetailData?.service_type?.enable_comments === true) {
                  <button
                    class="btn btn-primary btm-btn-height w-100"
                    (click)="openTemplate(addEditCommentTemplate, 'addComment')"
                  >
                    + Add Comment
                  </button>
                }
              </div>
              <div class="col">
                @if (jobDetailData?.service_type?.enable_uploads === true) {
                  <button
                    class="btn btn-outline-primary btm-btn-height w-100 bg-secondary-subtle"
                    (click)="openUploadPhotoComponent()"
                  >
                    + Attach Photo
                  </button>
                }
              </div>
            </div>
          }
        } @else {
          @if (
            !offlineMode &&
            jobDetailData?.status?.status_identity?.value !== 1 &&
            scheduleCheck &&
            availableStatusesListData?.length
          ) {
            <div class="dropdown pt-2">
              @if (availableStatusesListData?.length === 1) {
                <div
                  [ngStyle]="
                    availableStatusesListData[0]?.status?.additional_info?.style
                      ?.snubbed
                  "
                  class="btn w-100 rounded fw-bold py-3"
                  (click)="
                    changeJobStatus(
                      availableStatusesListData[0],
                      jobCancelTemplate,
                      inTransitTemplateRef,
                      queuedEventsTemplateRef,
                      siteUpdateRadiusWarningTemplate
                    )
                  "
                >
                  {{ availableStatusesListData[0]?.status?.name }}
                  <ng-template
                    *ngTemplateOutlet="
                      attachClockInOutToStatusTemplate;
                      context: { status: availableStatusesListData[0] }
                    "
                  ></ng-template>
                </div>
              } @else {
                <div
                  id="jobChangeStatus"
                  (click)="statusDropdownOpen = !statusDropdownOpen"
                >
                  <button
                    class="w-100 d-flex align-items-center justify-content-center flex-fill me-1 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary fw-bold"
                    (blur)="closeStatusDropDown()"
                  >
                    Update
                    <div class="ms-2">
                      @if (statusDropdownOpen) {
                        <span>
                          <i class="fas fa-chevron-up"></i>
                        </span>
                      } @else {
                        <span>
                          <i class="fas fa-chevron-down"></i>
                        </span>
                      }
                    </div>
                  </button>
                </div>
                @if (statusDropdownOpen) {
                  <div
                    class="dropdown-content-up rounded border border-secondary"
                  >
                    @for (item of availableStatusesListData; track item) {
                      <a
                        (click)="
                          changeJobStatus(
                            item,
                            jobCancelTemplate,
                            inTransitTemplateRef,
                            queuedEventsTemplateRef,
                            siteUpdateRadiusWarningTemplate
                          );
                          statusDropdownOpen = false
                        "
                        >{{ item?.status?.name }}
                        <ng-template
                          *ngTemplateOutlet="
                            attachClockInOutToStatusTemplate;
                            context: { status: item }
                          "
                        ></ng-template
                      ></a>
                    }
                  </div>
                }
              }
            </div>
          }
          @if (
            jobDetailData?.status?.status_identity?.value !== 1 && scheduleCheck
          ) {
            <div
              id="jobUpdateButtons"
              class="d-flex justify-content-between py-2 column-gap-1"
            >
              @if (jobDetailData?.service_type?.enable_comments === true) {
                <div
                  class="d-flex flex-column align-items-center justify-content-center w-100 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary"
                  (click)="openTemplate(addEditCommentTemplate, 'addComment')"
                >
                  <i class="fa-regular fa-message fs-5"></i>
                  <div>Add Comment</div>
                </div>
              }
              @if (jobCheckpointListData?.length) {
                <div
                  id="scanCheckpointTemplateId"
                  class="d-flex flex-column align-items-center justify-content-center w-100 bg-primary-subtle text-primary-emphasis btm-btn-height text-center rounded border border-primary"
                  (click)="openScanCPTemplate()"
                >
                  <div>Scan Checkpoint</div>
                </div>
              }
              @if (jobDetailData?.service_type?.enable_uploads === true) {
                <div
                  class="d-flex flex-column align-items-center justify-content-center w-100 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary"
                  (click)="openUploadPhotoComponent()"
                >
                  <i class="fa-solid fa-camera fs-5"></i>
                  <div>Upload Photo</div>
                </div>
              }
            </div>
          }
        }
      }
    </ng-container>
  } @else if (
    jobDetailData?.status?.status_identity?.value == 1 ||
    ([9, 10, 11, 12, 13].includes(
      jobDetailData?.status?.status_identity?.value
    ) &&
      !(isAdmin || isDispatchUser))
  ) {
    <!-- case where status is complete or (invoicing status and user is guard=> show job as completed/closed)-->
    @if (
      jobDetailData?.status?.status_identity?.value == 1 &&
      (isAdmin || isDispatchUser)
    ) {
      <div
        class="text-center d-flex align-items-center justify-content-center mb-2"
      >
        <button
          (click)="routeToReviewPage()"
          class="btn btn-outline-primary w-100 btn-lg"
        >
          View Docket
        </button>
      </div>
    }
    <div
      class="text-center p-2 fw-bold mb-1"
      [ngStyle]="
        jobDetailData?.can_reopen
          ? selectedJobStatus?.additional_info?.style?.snubbed
          : {
              color: 'var(--highlight-color)',
              background: 'var(--highlight-bg)',
            }
      "
    >
      {{ jobDetailData?.can_reopen ? "JOB COMPLETED" : "JOB CLOSED" }}
    </div>
    @if (
      jobDetailData?.can_reopen &&
      !offlineMode &&
      lastStatus?.status?.id &&
      jobDetailData?.status?.status_identity?.value == 1
    ) {
      <div
        class="text-center d-flex align-items-center justify-content-center mb-2"
      >
        <button
          (click)="moveJobBack()"
          class="btn btn-outline-danger w-100 btn-lg"
        >
          Reopen Job
        </button>
      </div>
    }
  } @else {
    @switch (jobDetailData?.status?.status_identity?.value) {
      @case (9) {
        <div
          class="text-center d-flex align-items-center justify-content-center mb-2"
        >
          <button
            (click)="routeToReviewPage()"
            class="btn btn-outline-primary w-100 btn-lg"
          >
            View Docket
          </button>
        </div>
        <div
          class="text-center p-2 fw-bold"
          [ngStyle]="selectedJobStatus?.additional_info?.style?.snubbed"
        >
          JOB COMPLETED
        </div>
      }
      @case (10) {
        <div
          class="text-center d-flex align-items-center justify-content-center mb-2"
        >
          <button
            (click)="reviewJob()"
            class="btn btn-outline-primary w-100 btn-lg"
          >
            View Docket
          </button>
        </div>
        <div
          class="text-center p-2 fw-semibold"
          [ngStyle]="selectedJobStatus?.additional_info?.style?.snubbed"
        >
          Completed
        </div>
      }
      @case (11) {
        <div
          class="text-center d-flex align-items-center justify-content-center mb-2"
        >
          <button
            (click)="routeToReviewPage()"
            class="btn btn-outline-primary w-100 btn-lg"
          >
            View Docket
          </button>
        </div>
        <div
          class="text-center p-2 fw-semibold"
          [ngStyle]="selectedJobStatus?.additional_info?.style?.snubbed"
        >
          {{ selectedJobStatus?.name }}
        </div>
      }
      @case (12) {
        <div
          class="text-center d-flex align-items-center justify-content-center mb-2"
        >
          <button
            (click)="routeToReviewPage()"
            class="btn btn-outline-primary w-100 btn-lg"
          >
            View Docket
          </button>
        </div>
        <div
          class="text-center p-2 fw-semibold"
          [ngStyle]="selectedJobStatus?.additional_info?.style?.snubbed"
        >
          {{ selectedJobStatus?.name }}
        </div>
      }
      @case (13) {
        <div
          class="text-center d-flex align-items-center justify-content-center mb-2"
        >
          <button
            (click)="routeToReviewPage()"
            class="btn btn-outline-primary w-100 btn-lg"
          >
            View Docket
          </button>
        </div>
        <div
          class="text-center p-2 fw-semibold"
          [ngStyle]="selectedJobStatus?.additional_info?.style?.snubbed"
        >
          {{ selectedJobStatus?.name }}
        </div>
      }
    }
  }
</ng-template>

<!-- edit response type  DIALOG -->
<ng-template
  #responseTypeTemplateRef
  let-responseTypeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Response Type

      <span class="float-end" (click)="responseTypeTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="mb-3">
        <gtapp-auto-complete
          [data]="responseTypeList"
          [maxLength]="256"
          placeHolder="Search Response Type"
          searchKeyword="name"
          [initialValue]="previousResponseTypeValue"
          [itemTemplate]="responseTypeTemplate"
          [addInitialKey]="isAdmin || isDispatchUser"
          (inputChanged)="onSearchResponseType($event)"
          (selected)="onSelectResponseType($event)"
          [inputId]="'rtId'"
          [enableCloseOption]="true"
          (fieldCleared)="editField('rt')"
        >
        </gtapp-auto-complete>
      </div>

      <ng-template #responseTypeTemplate let-item>
        @if (item?.key === 0) {
          <div>Add New Response Type</div>
        } @else {
          <div>{{ item?.name }}</div>
        }
      </ng-template>

      @if (jobDetailData?.response_type?.id) {
        <div class="row row-cols12 mt-2">
          <div class="col">
            <button
              (click)="
                responseTypeTemplateRef.close();
                updateJobDetail({ response_type_id: null })
              "
              class="btn btn-outline-danger btn-lg w-100"
            >
              Remove Response Type
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- edit service type  DIALOG -->
<ng-template
  #serviceTypeTemplateRef
  let-serviceTypeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Service Type

      <span class="float-end" (click)="serviceTypeTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="mb-3">
        <gtapp-auto-complete
          [data]="serviceTypeListData"
          [maxLength]="256"
          placeHolder="Search Service Type"
          searchKeyword="name"
          [initialValue]="previousServiceTypeValue"
          [itemTemplate]="serviceTypeTemplate"
          [addInitialKey]="isAdmin || isDispatchUser"
          (inputChanged)="onSTSearch($event)"
          (selected)="onServiceTypeSelect($event)"
          [inputId]="'stId'"
          [enableCloseOption]="true"
          (fieldCleared)="editField('st')"
        >
        </gtapp-auto-complete>
      </div>

      <ng-template #serviceTypeTemplate let-item>
        @if (item?.key === 0) {
          <div>Add New Service Type</div>
        } @else {
          <div>{{ item?.name }}</div>
        }
      </ng-template>

      @if (jobDetailData?.job_service_type?.id) {
        <div class="row row-cols12 mt-2">
          <div class="col">
            <button
              (click)="
                serviceTypeTemplateRef.close();
                updateJobDetail({ service_type_id: null })
              "
              class="btn btn-outline-danger btn-lg w-100"
            >
              Remove Service Type
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- JOB DECLINE DIALOG -->
<ng-template
  #jobDeclineTemplateRef
  let-data
  let-jobDeclineTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Decline
      <span class="float-end" (click)="jobDeclineTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!-- Request Detail Section start-->
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        placeholder="Decline Reason [160 chars]"
        cols="20"
        rows="4"
        wrap="hard"
        maxlength="160"
        type="text"
        [(ngModel)]="declineReason"
        id="declineReasonField"
      ></textarea>
      @if (declineReason) {
        <span
          class="input-group-text"
          (click)="
            declineReason = ''; clearAndFocusTextBox('declineReasonField')
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="jobDeclineTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="!declineReason"
          (click)="declineJob(); jobDeclineTemplateRef.close()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialogue for assign users -->
<ng-template
  #singleAssigneeSelectionTemplate
  let-data
  let-singleAssigneeSelectionTemplate="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      <span class="float-end" (click)="singleAssigneeSelectionTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="p-3">
        @if (selectedAssignee?.id) {
          <dl>
            <dt>Assigned To</dt>
            <dd
              class="link-edit"
              (click)="
                selectedAssignee = {}; shiftFocus('assigneLookupFieldId')
              "
            >
              <span> {{ selectedAssignee?.full_name }}</span>
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="assigneeList"
            placeHolder="Search/Select Assignee"
            searchKeyword="full_name"
            inputId="assigneLookupFieldId"
            [initialValue]="selectedAssignee?.full_name"
            [itemTemplate]="assigneeLookupTemplate"
            (inputChanged)="onAssigneeSearch($event)"
            (selected)="onAssigneeSelect($event)"
            [enableCloseOption]="true"
          >
          </gtapp-auto-complete>

          <ng-template #assigneeLookupTemplate let-item>
            <div class="d-flex gap-2 flex-wrap">
              <span>
                {{ item?.full_name }}
              </span>
              @if (item?.access_status === 2) {
                <div
                  class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Casual
                </div>
              }
              @if (
                selectedSiteExtraDetails?.preferred_user_ids?.includes(item?.id)
              ) {
                <div
                  class="text-success-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Preferred
                </div>
              }
            </div>
            @if (selectedSiteExtraDetails?.last_assignees?.[item?.id]) {
              <div class="small text-secondary">
                Previously Assigned:
                @if (
                  (selectedSiteExtraDetails?.last_assignees?.[item?.id]
                    | misc: "getXDaysAgo") > 1
                ) {
                  {{
                    selectedSiteExtraDetails?.last_assignees?.[item?.id]
                      | misc: "getXDaysAgo"
                  }}
                  day(s) ago |
                } @else {}
                {{
                  selectedSiteExtraDetails?.last_assignees?.[item?.id]
                    | misc: "eventDateGrouping"
                }}
              </div>
            }
            @if (item?.subcontractors?.length) {
              <div class="small text-secondary">
                🟧Subcontractor:
                <span class="subcontractor-name">{{
                  item?.subcontractors
                }}</span>
              </div>
            }
          </ng-template>
        }
      </div>

      <div class="row row-cols-2 mt-4">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="singleAssigneeSelectionTemplate.close()"
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              jobDetailData?.assignee?.[0]?.id == selectedAssignee?.id ||
              updateBtnPressed
            "
            (click)="updateAssignee(); singleAssigneeSelectionTemplate.close()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- JOB COMPLETE CONFIRMATION DIALOG -->
<ng-template
  #queuedEventsTemplateRef
  let-data
  let-queuedEventsTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Unsent Updates
      <span class="text-primary fw-semibold ms-4">{{
        itemsNotInServer?.length
      }}</span>
      @if (data?.pendingItemsCount >= itemsNotInServer?.length) {
        / {{ data?.pendingItemsCount }}
      }

      <span class="float-end" (click)="queuedEventsTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (offlineMode) {
      <div class="small-font mb-3">
        Events can be uploaded once the server connection has been restored.
      </div>
    }
    @if (askToRefreshPageToPullLatestData) {
      <div class="small-font mb-3">
        Refresh the data to get all the changes made to the job when you were
        offline
      </div>
    }

    @if (itemsNotInServer?.length) {
      <ng-container>
        <div class="px-2">Unable to complete with unsent updates.</div>

        @if (syncInProgress === true && !offlineMode) {
          <div
            class="alert alert-primary mb-3 align-items-center d-flex justify-content-between"
          >
            <div class="fw-bold">Syncing Data to Server</div>
            <div class="spinner-grow" role="status"></div>
          </div>
        }
        <div class="overflow-45vh">
          @for (update of itemsNotInServer; track update) {
            <div>
              <dl class="border border-2 p-2">
                <dt>
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      @if (update?.file) {
                        <span>
                          {{
                            [".mp4", ".mov", ".webm", ".mkv"].includes(
                              update?.file_extension
                            )
                              ? "Video"
                              : "Photo"
                          }}
                          {{
                            update?.event_action === 19
                              ? "[Device Library]"
                              : "[Camera]"
                          }}
                        </span>
                      } @else {
                        Comment
                      }
                      |
                      {{ update?.updated_at | customDate: "d MMM y HH:mm" }}
                    </div>
                    @if (update?.errorMessages?.length) {
                      <div (click)="deleteItemFromNativeDb(update)">
                        <i
                          class="fa-solid fa-trash md-font-size text-secondary"
                        ></i>
                      </div>
                    }
                  </div>
                </dt>
                <dd>
                  <div>
                    {{
                      update?.detail === "null" ||
                      update?.detail === "undefined"
                        ? ""
                        : update?.detail
                    }}
                  </div>
                  @if (update?.file) {
                    <ng-template
                      *ngTemplateOutlet="
                        filePreviewTemplate;
                        context: {
                          value: update,
                          inBrowser: update?.cachedData,
                        }
                      "
                    ></ng-template>
                  }
                </dd>
                <dd
                  [ngClass]="
                    update?.errorMessages?.length ? 'text-danger' : 'text-info'
                  "
                >
                  @if (update?.errorMessages?.length) {
                    Error:
                    {{
                      update?.errorMessages[update?.errorMessages?.length - 1]
                    }}
                  } @else {
                    In Queue
                  }
                </dd>
              </dl>
            </div>
          }
        </div>
      </ng-container>
    } @else {
      <div class="fw-semibold mb-3">No updates remain unsent.</div>
    }

    @if (!offlineMode) {
      <div class="row">
        @if (askToRefreshPageToPullLatestData) {
          <button
            type="button"
            class="btn btn-primary btn-lg w-100"
            (click)="reloadPage()"
          >
            Refresh Data
          </button>
        } @else if (!itemsNotInServer?.length) {
          <button
            class="btn btn-lg btn-primary w-100"
            (click)="queuedEventsTemplateRef.close()"
          >
            Ok
          </button>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #sealInfoTemplateRef let-sealInfoTemplateRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ sealInfo?.site_sealed ? "Cleared By" : "Edit Seal Details" }}
      <span class="float-end" (click)="sealInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (data) {
      <div class="input-group my-3">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            placeholder="Operator Name"
            [(ngModel)]="sealInfo.cleared_by"
            id="sealClearedByFieldId"
          />
          <label>Operator Name</label>
        </div>

        @if (sealInfo?.cleared_by) {
          <span
            class="input-group-text"
            (click)="
              sealInfo.cleared_by = ''; shiftFocus('sealClearedByFieldId')
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
    } @else {
      <div class="my-3">
        <label
          ><input
            class="form-check-input"
            type="checkbox"
            [checked]="sealInfo?.site_sealed"
            (change)="
              sealInfo?.site_sealed
                ? (sealInfo = { internal_check: true })
                : (sealInfo = { internal_check: true, site_sealed: true })
            "
          />
          Site Sealed
        </label>
      </div>
      @if (sealInfo?.site_sealed) {
        <div class="input-group my-3">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              placeholder="Operator Name"
              [(ngModel)]="sealInfo.cleared_by"
              id="sealClearedByFieldId"
            />
            <label>Operator Name</label>
          </div>

          @if (sealInfo?.cleared_by) {
            <span
              class="input-group-text"
              (click)="
                sealInfo.cleared_by = ''; shiftFocus('sealClearedByFieldId')
              "
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      } @else {
        <div class="form-group input-group col">
          <textarea
            class="form-control"
            placeholder="Reason"
            rows="2"
            wrap="hard"
            type="text"
            autofocus
            [(ngModel)]="sealInfo.uncleared_reason"
            id="sealUnClearedReasonFieldId"
          ></textarea>
          @if (sealInfo?.uncleared_reason) {
            <span
              class="input-group-text"
              (click)="
                sealInfo.uncleared_reason = '';
                shiftFocus('sealUnClearedReasonFieldId')
              "
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      }
    }

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="sealInfoTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            sealInfo?.site_sealed
              ? !sealInfo?.cleared_by
              : !sealInfo.uncleared_reason
          "
          (click)="
            updateJobDetail({ seal_info: sealInfo });
            sealInfoTemplateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- edit Response Received time  DIALOG -->
<ng-template
  #jobReceivedAtTemplateRef
  let-jobReceivedAtTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Edit Alarm Received

      <span class="float-end" (click)="jobReceivedAtTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="row row-cols-1 mb-2">
        <div class="col">
          <div class="form-floating mb-2">
            <input
              type="datetime-local"
              class="form-control"
              placeholder="Alarm Received"
              [(ngModel)]="jobReceivedAtDateTime"
              [ngModelOptions]="{ standalone: true }"
              (change)="formatReceivedAtDatetime($event)"
            />
            <label>Alarm Received</label>
          </div>
        </div>
      </div>

      <div class="row row-cols-2 mt-2">
        <div class="col">
          <button
            (click)="jobReceivedAtTemplateRef.close()"
            class="btn btn-dark btn-lg w-100"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            (click)="
              updateJobReceivedTime(jobReceivedAtDateTime);
              jobReceivedAtTemplateRef.close()
            "
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              !jobReceivedAtDateTime ||
              jobReceivedAtDateTime == jobDetailData?.job_received_at
            "
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- ADD COMMENT POPOVER / DIALOG -->
<ng-template
  #addEditCommentTemplate
  let-addEditCommentTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="addEditCommentTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="data.newComment"
          id="updateCommentBox"
        ></textarea>
        @if (data?.newComment) {
          <span
            class="input-group-text"
            (click)="
              data.newComment = ''; clearAndFocusTextBox('updateCommentBox')
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="addEditCommentTemplateRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (data?.id && (data?.file || data?.file_url)) {
            <button
              class="btn btn-lg w-100"
              [disabled]="data?.previousComment === data?.newComment"
              (click)="addEditCommentTemplateRef.close(data)"
              [ngClass]="data?.newComment ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="
                !data?.newComment || data?.previousComment === data?.newComment
              "
              (click)="addEditCommentTemplateRef.close(data)"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Cancel Job dialoge -->
<ng-template #jobCancelTemplate let-jobCancelTemplate="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      Confirmation Needed

      <span class="float-end" (click)="jobCancelTemplate.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="alert alert-danger">
        @if (data?.delete) {
          <div>
            WARNING: Managers will be notified. This action cannot be reversed.
          </div>
        } @else {
          <div>
            WARNING: Report recipients will be notified of this action. This
            action cannot be reversed.
          </div>
        }
      </div>
      <div class="form-floating">
        <input
          class="form-control"
          type="text"
          [(ngModel)]="cancelReason"
          placeholder=" {{
            data?.delete ? 'Delete Reason' : 'Cancellation reason'
          }}"
        /><label>{{
          data?.delete ? "Delete Reason" : "Cancellation reason"
        }}</label>
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="jobCancelTemplate.close(false)"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-danger btn-lg w-100"
            [disabled]="!cancelReason || updateBtnPressed"
            (click)="jobCancelTemplate.close(cancelReason)"
          >
            {{ data?.delete ? "Delete Job" : " Cancel Job" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- UPDATE SITE CONTACTS POPOVER / DIALOG -->
<ng-template #modifySiteContactRef let-modifySiteContactRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Onsite Contacts

      <span class="float-end" (click)="modifySiteContactRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <table class="table my-2">
      <tbody>
        @for (contact of siteContactList; track contact) {
          <tr>
            <td>
              <div class="d-flex">
                <div class="flex-grow-1">
                  <span
                    class="cursor-pointer"
                    (click)="
                      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                        jobDetailData?.status?.status_identity?.value
                      ) &&
                      (isAdmin || isDispatchUser)
                        ? offlineMode
                          ? showOfflineMessage()
                          : addRemoveSiteContact(contact)
                        : ''
                    "
                  >
                    @if (isAdmin || isDispatchUser) {
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="contact?.selected"
                        [disabled]="
                          !(
                            ![1, 2, 3, 9, 10, 11, 12, 13].includes(
                              jobDetailData?.status?.status_identity?.value
                            ) &&
                            !offlineMode &&
                            (isAdmin || isDispatchUser)
                          )
                        "
                      />
                    }
                    <span class="ms-2">{{ contact?.full_name }}</span>
                  </span>
                </div>
                <div
                  (click)="
                    offlineMode
                      ? showOfflineMessage()
                      : openSiteContactTemplate(contact)
                  "
                >
                  <i
                    class="fa-solid fa-circle-info md-font-size text-secondary me-2"
                  ></i>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (
      (isAdmin || isDispatchUser) &&
      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
        jobDetailData?.status?.status_identity?.value
      )
    ) {
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="modifySiteContactRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            (click)="addLocationContact()"
          >
            Add New Contact
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- Additional Information/ internal notes POPOVER / DIALOG -->
<ng-template
  #jobExtraInfoTemplateRef
  let-data
  let-jobExtraInfoTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?._type === "in" ? "Internal Notes" : "Additional Information" }}
      <span class="float-end" (click)="jobExtraInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!-- Request Detail Section start-->
    @if (data?._type === "in") {
      <div class="mb-3">
        Interal notes will not be included on dockets (reports).
      </div>
    }
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        [placeholder]="
          data?._type === 'in' ? 'Internal Notes' : 'Additional Information'
        "
        cols="20"
        rows="5"
        wrap="hard"
        maxlength="900"
        type="text"
        [(ngModel)]="updatedJobExtraInfo"
        id="aiField"
      ></textarea>
      @if (updatedJobExtraInfo) {
        <span
          class="input-group-text"
          (click)="updatedJobExtraInfo = ''; clearAndFocusTextBox('aiField')"
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="jobExtraInfoTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="updatedJobExtraInfo === data?.currentValue"
          (click)="
            updateRequestDetails(data?._type); jobExtraInfoTemplateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>

<!-- UPDATE MONITORING COMPANY DIALOG -->
<ng-template #modifyMCTemplate let-modifyMCTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Monitoring Company
      <span class="float-end" (click)="modifyMCTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="mb-3">
      <gtapp-auto-complete
        [data]="monitoringCompanyList"
        placeHolder="Monitoring Company"
        searchKeyword="company_name"
        [itemTemplate]="MCTemplate"
        [initialValue]="mcInputValue"
        [addInitialKey]="isAdmin || isDispatchUser"
        (inputChanged)="onMcSearch($event)"
        (selected)="addMC($event)"
        [inputId]="'mcId'"
        [enableCloseOption]="true"
        (fieldCleared)="editField('mc')"
      >
      </gtapp-auto-complete>
    </div>

    <ng-template #MCTemplate let-item>
      @if (item?.key === 0) {
        <div>Add Monitoring Company</div>
      } @else {
        <div>
          {{ item.company_name }}
        </div>
      }
    </ng-template>
    @if (jobDetailData?.monitoring_company?.id) {
      <div class="row row-cols-1 mt-2 mx-auto">
        <div class="col">
          <button
            (click)="
              modifyMCTemplate.close();
              updateJobDetail({ monitoring_company_id: null })
            "
            class="btn btn-danger btn-lg px-5"
          >
            Clear
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- Docket No DIALOG -->
<ng-template
  #modifyExternalJobIdTemplate
  let-modifyExternalJobIdTemplate="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Job Number<span
        class="float-end"
        (click)="modifyExternalJobIdTemplate.close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <!-- Docket No Section start-->
    <div class="input-group">
      <div class="form-floating">
        <input
          class="form-control"
          type="text"
          placeholder="Job Number"
          [(ngModel)]="externalNewJobId"
          autocomplete="off"
          maxlength="32"
          id="eJIdField"
          oninput="this.value = this.value.toUpperCase()"
        />
        <label>Job Number</label>
      </div>
      @if (externalNewJobId) {
        <span
          class="input-group-text"
          (click)="externalNewJobId = ''; clearAndFocusTextBox('eJIdField')"
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="modifyExternalJobIdTemplate.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="externalOldJobId === externalNewJobId"
          (click)="updateJobId(); modifyExternalJobIdTemplate.close()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- Add OnSite/Offsite datetime model -->
<ng-template
  #onsiteTimeTempalteRef
  let-onsiteTimeTempalteRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      {{ data.name }} Time
      <span class="float-end" (click)="onsiteTimeTempalteRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Select Time"
        [(ngModel)]="dateTimeValue"
        (change)="changeUserProvidedTime($event)"
        [min]="jobStatusTimeChange?.created_at"
        [max]="jobStatusTimeChange?.currentTime"
      />
      <label>Select Time</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="onsiteTimeTempalteRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="
            statusUpdateBtnPressed = true; onsiteTimeTempalteRef.close(data)
          "
          [disabled]="!jobStatusTimeChange?.valid || statusUpdateBtnPressed"
        >
          {{ data?.clockOut ? "Confirm" : "Update" }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- in transit eta tempalte-->
<ng-template #inTransitTemplateRef let-inTransitTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      ETA to Site
      <span
        class="float-end"
        (click)="inTransitTemplateRef.close(false); etaChangeReason = null"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (jobDetailData?.showEta) {
      <div class="form-floating mb-2">
        <input
          class="form-control"
          type="text"
          placeholder="Reason for update"
          [(ngModel)]="etaChangeReason"
          autocomplete="off"
        />
        <label>Reason for update</label>
      </div>
    }
    <div class="border rounded p-2 mb-2 d-flex flex-wrap gap-3">
      @for (eta of etaValueList; track eta) {
        <button
          class="btn btn-md btn-light border"
          (click)="updateEtaTime(eta, 'button')"
        >
          {{ eta?.key }}
        </button>
      }
    </div>

    <div class="d-flex align-items-center gap-2 mb-2 justify-content-center">
      <input
        type="tel"
        inputmode="numeric"
        pattern="[0-9]*"
        class="border rounded p-1 fs-4 text-center fw-semibold col-4 border-3"
        [value]="etaTimeinMinutes"
        (input)="updateEtaTime($event, 'number')"
      />
      <label class="small fw-semibold">Minutes</label>
    </div>

    <div class="form-floating mb-2">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="ETA to Site"
        [(ngModel)]="etaValue"
        [min]="minEta"
        (change)="updateEtaTime($event, 'date')"
      />
      <label> ETA to Site</label>
    </div>

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="inTransitTemplateRef.close(false); etaChangeReason = null"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="inTransitTemplateRef.close(etaValue); etaChangeReason = null"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- JOB WELFARE INTERVAL DIALOG -->
<ng-template #welfareIntervalTemplate let-welfareIntervalTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Welfare Check Interval
      <span class="float-end" (click)="welfareIntervalTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating">
      <select
        class="form-select"
        id="welfareChecks"
        [(ngModel)]="selectedInterval"
      >
        @for (interval of intervalData; track interval) {
          <option [value]="interval.value">
            {{ interval.name }}
          </option>
        }
      </select>
      <label for="">Welfare Check Interval</label>
    </div>
    @if (selectedInterval > 0) {
      <div class="alert">
        <div class="mb-2">
          Guards will be reminded to submit a welfare check
          <span class="fw-bold">
            {{ welfareReminderDict?.[selectedInterval] }} minutes before</span
          >
          the interval set above.
        </div>
        <div>
          Maximum inactivity time allowed before a missed welfare check is
          recorded:
          <span class="fst-italic fw-bold">
            {{ selectedInterval }} minutes.
          </span>
        </div>
      </div>
    }
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="welfareIntervalTemplate.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="selectedInterval == jobDetailData?.interval_check"
          (click)="updateInterval(selectedInterval)"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #siteUpdateRadiusWarningTemplate
  let-data
  let-siteUpdateRadiusWarningTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Warning
      <span
        class="float-end"
        (click)="siteUpdateRadiusWarningTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="text-center">
      Your current position doesn't match the required location.
    </div>
    <div class="my-3">
      <button
        class="btn btn-lg w-100 btn-primary"
        (click)="siteUpdateRadiusWarningTemplateRef.close(true)"
      >
        Continue
      </button>
    </div>

    @if (data?.gps?.lat && data?.scan_detail?.lat && data?.min_distance) {
      <gtapp-map-leaflet
        [latLon]="data?.gps"
        [scannedCheckpointDetails]="data"
        mapId="siteWarningMap"
      ></gtapp-map-leaflet>
    }</div
></ng-template>

<ng-template
  #checkListCompleteTemplateRef
  let-checkListCompleteTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      <span
        class="float-end"
        (click)="checkListCompleteTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <ng-container>
        <div
          class="border bg-secondary-subtle text-dark p-2 mb-2 gt-multi-line"
        >
          {{ data?.note }}
        </div>
      </ng-container>

      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="1"
          wrap="hard"
          placeholder="Optional Comments"
          autofocus
          [(ngModel)]="data.newComment"
          id="updateCommentBox"
        ></textarea>
        @if (data?.newComment) {
          <span
            class="input-group-text"
            (click)="
              clearAndFocusTextBox('updateCommentBox'); data.newComment = ''
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      @if (data?.isLastItem) {
        <div class="m-2 p-2">
          <div class="mb-2">This is the final task at this site.</div>
          <div>
            Mark <span class="fw-semibold">COMPLETE</span> and update status to
            <span class="fw-semibold">OFFSITE</span>?
          </div>
        </div>
      }

      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-secondary btn-lg w-100"
            (click)="checkListCompleteTemplateRef.close(false)"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg w-100"
            [ngClass]="data?.isLastItem ? 'btn-success' : 'btn-primary'"
            (click)="checkListCompleteTemplateRef.close(data)"
          >
            {{ data?.isLastItem ? "OK" : "Mark Complete" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #filePreviewTemplate let-update="value" let-inBrowser="inBrowser">
  <div class="media-view mb-2" (click)="$event.stopImmediatePropagation()">
    @if ([".mp4", ".mov", ".webm", ".mkv"].includes(update?.file_extension)) {
      <video controls muted class="media-file">
        <source [src]="inBrowser ? getFileSrc(update?.file) : update?.file" />
        Your browser does not support the video tag.
      </video>
    } @else if ([".mp3"].includes(update?.file_extension)) {
      <audio
        [src]="inBrowser ? getFileSrc(update?.file) : update?.file"
        controls
        controlslist="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ></audio>
    } @else {
      <img
        (click)="onOpenImage($event, update)"
        [src]="inBrowser ? getFileSrc(update?.file) : update?.file"
        class="media-file"
      />
    }
  </div>
</ng-template>

<ng-template #selectedCheckpointDetail let-item="value">
  @if (!item?.updated_datetime && !item?.is_deleted) {
    <div class="d-flex align-items-center">
      <a
        [href]="
          'https://www.google.com/maps/search/?api=1&query=' +
          item?.latitude +
          ',' +
          item?.longitude
        "
        target="_blank"
        class="text-secondary"
      >
        <span>
          <i class="fa-solid fa-map-location-dot fs-4"></i>
        </span>
      </a>
    </div>
  }

  @if (item?.updated_datetime) {
    <div class="d-flex align-items-center">
      <span>
        <i class="fa-solid fa-check fs-4 text-success"></i>
      </span>
    </div>
  }

  <div class="flex-grow-1 ms-3 me-2">
    <div class="d-flex flex-column gap-2">
      <div class="fw-semibold">{{ item?.name }}</div>
      @if (item?.updated_datetime) {
        <div class="text-secondary small-font">
          {{ item?.updated_datetime | customDate: "d MMM y HH:mm" }}
          |
          {{ item?.user_name }}
        </div>
      }
    </div>
  </div>

  @if (item?.qr_code) {
    <div class="me-3 cp-scanned-icon">
      @if (item?.is_nfc_code) {
        <img
          src="assets/images/NFC_logo.avif"
          alt="NFC Code"
          width="30"
          class="mb-0 bg-white p-1 rounded"
        />
        @if (
          item?.is_nfc_code &&
          item?.qr_code &&
          !nfcReaderAvailable &&
          !largeView
        ) {
          <div class="d-flex justify-content-center">
            <span
              title="NFC Checkpoints Cannot Be Scanned With This Device/Browser"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              class="text-danger fw-bold fs-4"
              ><i class="fa-solid fa-triangle-exclamation"></i
            ></span>
          </div>
        }
      } @else {
        <img
          src="assets/images/qr-code-logo.avif"
          alt="QR Code"
          width="30"
          class="mb-0 bg-white p-1 rounded"
        />
      }
    </div>
  }
</ng-template>

<ng-template #promptTemplate let-promptTemplateRef="dialogRef" let-data>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="promptTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <gtapp-mobile-form-input-data [mobileFormDataInput]="data">
    </gtapp-mobile-form-input-data>
  </div>
</ng-template>

<ng-template #shiftPositionTempate let-shiftPositionTempateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Shift Position<span
        class="float-end"
        (click)="shiftPositionTempateRef.close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <!-- Docket No Section start-->
    <div class="input-group">
      <div class="form-floating">
        <input
          class="form-control"
          type="text"
          placeholder="Shift Position"
          [(ngModel)]="newShiftPositionValue"
          autocomplete="off"
          id="shiftPositionField"
        />
        <label>Shift Position</label>
      </div>
      @if (newShiftPositionValue) {
        <span
          class="input-group-text"
          (click)="
            newShiftPositionValue = '';
            clearAndFocusTextBox('shiftPositionField')
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="shiftPositionTempateRef.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="oldShiftPositionValue === newShiftPositionValue"
          (click)="
            updateJobDetail({ position: newShiftPositionValue });
            shiftPositionTempateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #attachClockInOutToStatusTemplate let-status="status">
  @if (
    shiftClockInOutParms.requiresClockInOut &&
    [2].includes(jobDetailData?.service_type?.type_identity)
  ) {
    @if (
      status?.status?.status_identity?.value == 4 &&
      !shiftClockInOutParms.hasUserClockedIn
    ) {
      (CLOCK IN)
    }
    @if (
      status?.status?.status_identity?.value == 5 &&
      !shiftClockInOutParms.hasUserClockedOut
    ) {
      (CLOCK OUT)
    }
  }
</ng-template>
